// This file was copied from site scanner. Planned to move it to ui-common
import React, { FC, ReactElement, useCallback, useRef, useState } from 'react';

import classNames from 'classnames';

import {
	BUTTON_TYPES,
	CheckCircle,
	Copy,
	EvButton,
	EvIconButton,
	EvToast,
	TOAST_STATUS,
	XCircle
} from '@evinced-private/ui-common';

import { ClipboardHelper } from '../../helpers/ClipboardHelper';

const copyStates = {
	copying: {
		text: 'Copying. Please wait',
		icon: null,
		state: TOAST_STATUS.INFO
	},
	success: {
		text: 'Copied to Clipboard',
		icon: CheckCircle,
		state: TOAST_STATUS.SUCCESS
	},
	error: {
		text: 'Copy Attempt Error',
		icon: XCircle,
		state: TOAST_STATUS.FAIL
	}
};

interface ICopyToClipboardProps {
	textToCopy: string;
	copyButtonText?: string;
	renderJustIcon?: boolean;
	className?: string;
	iconTitle?: string;
	buttonType?: BUTTON_TYPES;
	icon?: string;

	dataAutomationId?: string;
}

type copyStateItem = {
	text: string;
	icon: string;
	state: TOAST_STATUS;
};

export const CopyToClipboard: FC<ICopyToClipboardProps> = ({
	renderJustIcon,
	textToCopy,
	className,
	dataAutomationId,
	copyButtonText = 'Copy Issue Link',
	iconTitle = 'Copy selector',
	buttonType = BUTTON_TYPES.SECONDARY,
	icon = Copy
}) => {
	const [copyState, setCopyState] = useState<copyStateItem>(copyStates.copying);
	const [showAnnouncement, setShowAnnouncement] = useState<boolean>(false);
	const [buttonRef, setbuttonRef] = useState(useRef(null));

	const copyTextLinkButton = useRef(null);

	const onToastClose = (): void => {
		setShowAnnouncement(false);
		buttonRef.current.focus();
	};

	const renderToast = (): ReactElement => (
		<EvToast
			announcement={copyState.text}
			status={copyState.state}
			show={showAnnouncement}
			onToastClose={onToastClose}
		/>
	);

	const copyToClipboard = (text): void => {
		const isCopied = ClipboardHelper.copyToClipboard(text);
		setCopyState(isCopied ? copyStates.success : copyStates.error);
		setShowAnnouncement(true);
	};

	const copyButtonSelector = useCallback(
		(copyToClipboardButton: React.RefObject<HTMLButtonElement>): void => {
			setbuttonRef(copyToClipboardButton);
			copyToClipboard(textToCopy);
		},
		[textToCopy]
	);

	const copyTextLink = useCallback((): void => {
		setbuttonRef(copyTextLinkButton);
		copyToClipboard(textToCopy);
	}, [textToCopy]);

	return (
		<div className={classNames('copy-to-clipboard', className)}>
			{showAnnouncement && renderToast()}
			<div id="announce" className="sr-only" aria-live="assertive">
				{copyState.text !== copyStates.copying.text && <p>{copyState.text}</p>}
			</div>
			<div className="copy-text" data-automation-id={dataAutomationId}>
				{renderJustIcon ? (
					<EvIconButton
						ref={buttonRef}
						icon={icon}
						ariaLabel={iconTitle}
						onClick={() => copyButtonSelector(buttonRef)}
					/>
				) : (
					<EvButton ref={copyTextLinkButton} type={buttonType} onClick={copyTextLink}>
						{copyButtonText}
					</EvButton>
				)}
			</div>
		</div>
	);
};
